import { Candidate } from '@/lib/model';
import * as React from 'react';
import './index.scss';

export interface CandidatesProps {
  data: Candidate[];
}

const Person: React.FC<Candidate> = ({
  fullName,
  partyName,
  fillColor,
  coalitions,
}) => {
  const [isHover, setIsHover] = React.useState(false);

  return (
    <div
      className="Candidates__person"
      style={isHover ? { backgroundColor: fillColor } : undefined}
      onMouseEnter={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        setIsHover(false);
      }}
    >
      <div>
        <span className="Candidates__person__name">{fullName}</span>
        <div className="Candidates__person__collision">
          {coalitions.map((c, i) => (
            <div
              style={{
                backgroundImage: `url(${c.logo}`,
              }}
              key={i.toString()}
            />
          ))}
        </div>
      </div>
      <div className="Candidates__party__name">
        <span>{partyName}</span>
      </div>
    </div>
  );
};

export const Candidates: React.FC<CandidatesProps> = ({ data }) => (
  <div className="Candidates">
    <span className="Candidates__label">
      Candidati nel collegio uninominale:
    </span>
    {data
      .sort((a: Candidate, b: Candidate) => a.position - b.position)
      .map((candidate, i) => (
        <Person {...candidate} key={i.toString()} />
      ))}
  </div>
);
